//@ts-nocheck
import React, { useEffect, useRef, useState } from 'react';
import { Label, Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { Toaster, toast } from 'sonner';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import ConfettiExplosion from 'react-confetti-explosion';
import { CheckCircleColorIcon } from '../../../components/icons';


interface StepData {
  id: string;
  question_input_type: string;
  question_title: string;
  value: any;
  type: string;
  question_input_option: string;
  question_mandatory: string;
  step_order: number;
  required: boolean;
  className: string;
}

interface FormErrors {
  [key: string]: string;
}


interface FormValues {
  [key: string]: StepData;
  // Add any other properties as needed

}


interface DynamicSurveyFormProps {
  formSteps: FormElement[];
  // submitStepIntegrationResponse: (integrationResponse: any[]) => Promise<void>;
  // formikHandleBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  // setFieldTouched: (field: string, isTouched?: boolean, shouldValidate?: boolean) => void;
  // values: any;

  integrationResponse: any[];
  setIntegrationResponse: React.Dispatch<React.SetStateAction<any[]>>;
  setShowThankYouMessage: React.Dispatch<React.SetStateAction<boolean>>;
  showThankYouMessage: boolean;
  setLoadingForm: boolean;
  loadingForm: boolean;
}

const ApplicationDyanamic: React.FC<DynamicSurveyFormProps> = ({
  steps,
  formSteps,
  // submitStepIntegrationResponse,
  // formikHandleBlur,
  integrationResponse,
  setIntegrationResponse,
  setShowThankYouMessage,
  showThankYouMessage,
  setLoadingForm,
  loadingForm,
  values,
  onSubmit,
  parentFormData
}) => {
  const [selectedRating, setSelectedRating] = React.useState<number>(0);
  const [selectedSmiley, setSelectedSmiley] = React.useState<string>('');
  const [selectedThumb, setSelectedThumb] = useState<number | null>(null);
  const dropdownStep = steps?.find((step: { question_input_type: string; }) => step?.question_input_type === 'dropdown');
  const dropdownOptions = dropdownStep ? JSON.parse(dropdownStep.question_input_option) : [];
  const [selected, setSelected] = useState(dropdownOptions.length > 0 ? dropdownOptions[0] : null);
  const [formValues, setFormValues] = useState<FormValues>({});
  const [formErrors, setFormErrors] = useState<FormErrors>({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [videoFile, setVideoFile] = useState(null);
  const [audioFile, setAudioFile] = useState(null)
  const [fileSet, setFileSet] = useState(null);
  const [selectedYes, setSelectedYes] = useState(null);

  const smileyOptions = ['sad', 'ok', 'happy'];


  useEffect(() => {
    if (isSubmitting) {
      const errors = validateForm();
      setFormErrors(errors);
      if (Object.keys(errors).length === 0) {
        const convertedData = convertData(formValues);
        submitForm(convertedData);

        setIsSubmitting(false);
      } else {

        setIsSubmitting(false);
      }
    }
  }, [isSubmitting]);


  const convertData = (formValues: any) => {
    return Object.values(formValues);
  };


  const handleInputChange = (id, value, step) => {
    const parsedValue = step.question_input_type === "number" ? Number(value) : value;

    const newValue = {
      id: id,
      value: value
    };

    setFormValues((prev) => ({

      ...prev,
      [id]: {
        ...prev[id],
        response: value,
        id: id

      },
    }));

    if (formErrors[id]) {
      setFormErrors(prevErrors => ({
        ...prevErrors,
        [id]: ''
      }));
    }
  };


  const validateForm = () => {
    const errors = {};
    steps.forEach(step => {

      if (step.question_mandatory === true && !formValues[step.id]?.response) {
        errors[step.id] = 'This field is required';
      }
    });
    return errors;
  };

  const formatAnswersForSubmission = () => {
    return Object.keys(formValues).map((id) => ({
      id: formValues[id].id,
      value: formValues[id].response, // Ensure it correctly captures numbers
    }));
  };


  const handleCheckboxChange = (e, id, optionId, step) => {

    const isChecked = e.target.checked;

    setFormValues((prevValues) => {
      // Parse options and create a mapping of id -> label
      const checkboxOptions = JSON.parse(step.question_input_option);
      const labelMap = checkboxOptions.reduce((acc, option) => {
        acc[option.id] = option.label;
        return acc;
      }, {});

      const existingResponses = prevValues[id]?.response || [];

      let newResponses;
      if (isChecked) {
        // Add new response object if checked
        newResponses = [...existingResponses, { id: optionId, value: labelMap[optionId] }];
      } else {
        // Remove unchecked option
        newResponses = existingResponses.filter((response) => response.id !== optionId);
      }

      return {
        ...prevValues,
        [id]: {
          step_id: id,
          step_type: step.question_input_type,
          response: newResponses, // Store [{ id, value }]
          step_header: step.question_title,
          id: id
        },
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateForm();

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      toast.error('Please fill all required fields');
      return;
    }

    setLoadingForm(true);

    try {
      const formattedAnswers = formatAnswersForSubmission();


      const combinedFormData = {
        ...parentFormData,
        answers: formattedAnswers
      };


      await onSubmit(combinedFormData);
      // setFormValues({});
      setSelected(dropdownOptions.length > 0 ? dropdownOptions[0] : null);
      setFormErrors({});
      setShowConfetti(true);
    } catch (error) {
      console.error('Form submission error:', error);
      toast.error('Failed to submit form.');
    } finally {
      setLoadingForm(false);
    }
  };



  const dropdownRef = useRef<HTMLDivElement>(null);

  // Add click outside handler
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);



  const handleFileChangeVideo = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("video/")) {
      setVideoFile(URL.createObjectURL(file));
    } else {
      toast.warning("Please select a valid video file.");
    }
  };

  const handleFileChangeAudio = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("audio/")) {
      setAudioFile(URL.createObjectURL(file));
    } else {
      toast.warning("Please select a valid audio file.");
    }
  };

  const handleFileChangeFile = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("file/")) {
      setFileSet(URL.createObjectURL(file));
    } else {
      toast.warning("Please select a valid file.");
    }
  };

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [filePreview, setFilePreview] = useState(null);

  const handleFileChange = (event, id) => {
    const selectedFile = event.target.files[0];
  
    if (selectedFile && (selectedFile.type === "application/pdf" || selectedFile.type.includes("officedocument") || selectedFile.type.includes("word"))) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
      setFilePreview(URL.createObjectURL(selectedFile));
  
      // Update form values with only id & value
      setFormValues((prev) => ({
        ...prev,
        [id]: { id: id, value: selectedFile }, // Store correctly
      }));
    } else {
      alert("Please upload a valid PDF or DOC file.");
    }
  };
  


  const handleSelectYes = (value, event, id) => {
    event?.preventDefault(); // Prevents form submission
    setSelectedYes(value);

    setFormValues((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        response: value, // Store the selected value in formValues
        id: id
      },
    }));
  };



  const renderFormElement = (step: { question_input_type: any; id: any; question_title: any; question_mandatory: any; question_input_option: any; }) => {
    const { id, question_input_type, question_title, question_mandatory, question_input_option } = step;
    const isRequired = Boolean(question_mandatory);
    const selectedValues = formValues[id]?.response || [];
    const value = formValues[id]?.response || '';
    const toggleDropdown = (id) => {
      setIsOpen((prev) => ({
        ...prev,
        [id]: !prev[id],
      }));
    };

    const toggleOption = (id, optionId, options) => {
      const selectedValues = formValues[id]?.response || [];

      // Corrected way to check if option is already selected
      const newSelectedValues = selectedValues.some(selected => selected.id === optionId)
        ? selectedValues.filter(selected => selected.id !== optionId)
        : [...selectedValues, { id: optionId, value: options.find(opt => opt.id === optionId)?.label }];

      setFormValues((prev) => ({
        ...prev,
        [id]: {
          ...prev[id],
          response: newSelectedValues, // Store as an array of objects
          id: id,
        },
      }));
    };


    //     const toggleOption = (id, optionId) => {
    //       const selectedValues = formValues[id]?.response || [];
    //       const newSelectedValues = selectedValues.includes(optionId)
    //         ? selectedValues.filter((selectedId) => selectedId !== optionId)
    //         : [...selectedValues, optionId];
    // console.log(newSelectedValues,"newSelectedValues");

    //       setFormValues((prev) => ({
    //         ...prev,
    //         [id]: {
    //           ...prev[id],
    //           response: newSelectedValues,
    //           id: id
    //         },
    //       }));
    //     };

    const removeSelected = (id, optionId) => {
      const selectedValues = formValues[id]?.response || [];
      const newSelectedValues = selectedValues.filter((selectedId) => selectedId !== optionId);

      setFormValues((prev) => ({
        ...prev,
        [id]: {
          ...prev[id],
          response: newSelectedValues,
        },
      }));
    };

    const commonProps = {
      id,
      name: id,
      value: value,
      onChange: (e) => handleInputChange(id, e.target.value, step),
      required: isRequired,
      className: `mt-[-2px] p-2 px-4 block w-full border-gray-300 !outline-offset-[-1px] input_hover rounded-md shadow-sm placeholder:text-[14px] md:placeholder:text-[16px] lg:placeholder:text-[14px] text-[14px] md:text-sm lg:text-sm ${formErrors[id] ? 'border-red-500' : ''}`
    };
    switch (step.question_input_type) {
      case 'text':
        return (
          <div key={step.id} className="mb-4 flex flex-col gap-y-2">
            <label htmlFor={step.id} className="block text-[13px]  md:text-[16px] lg:text-[16px] leading-6 font-medium text-gray-700">
              {step.question_title}
            </label>

          </div>
        );
      case 'heading':
        return (
          <div key={step.id} className="mb-4 flex flex-col gap-y-2">
            <h2 className="text-[16px] md:text-[18px] lg:text-xl font-bold">{step.question_title}</h2>
          </div>
        );
      case 'input':
        return (
          <div key={step.id} className="mb-2 md:mb-4 lg:mb-4 flex flex-col gap-y-1 md:gap-y-2 lg:gap-y-2">
            <label htmlFor={step.id} className="block text-[14px] md:text-[14px] lg:text-[14px] leading-4 md:leading-5 lg:leading-6 font-medium text-gray-700">
              {step.question_title}
              {isRequired === true && <span className='text-red-500 ml-1 text-[14px]'>*</span>}
            </label>
            <input
              {...commonProps}
              type={question_input_type === 'number' ? 'number' : 'text'}
              placeholder="Enter your answer"
            // onBlur={handleBlur}
            />
            {formErrors[id] && <p className="mt-[-4px] text-sm text-red-500">{formErrors[id]}</p>}
          </div>
        );
      case 'textarea':
        return (
          <div key={step.id} className="mb-2 md:mb-4 lg:mb-4 flex flex-col gap-y-1 md:gap-y-2 lg:gap-y-2">
            <label htmlFor={step.id} className="block text-[14px] md:text-[14px] lg:text-[14px] leading-4 md:leading-5 lg:leading-6 font-medium text-gray-700">
              {step.question_title}
              {isRequired === true && <span className='text-red-500 ml-1 text-[14px]'>*</span>}
            </label>
            <textarea
              {...commonProps}
              type={question_input_type === 'number' ? 'number' : 'textarea'}
              placeholder="Enter your answer"
            />
            {formErrors[id] && <p className="mt-[-4px] text-sm text-red-500">{formErrors[id]}</p>}
          </div>
        );
      case 'email':
        return (
          <div key={step.id} className="mb-2 md:mb-4 lg:mb-4 flex flex-col gap-y-1 md:gap-y-2 lg:gap-y-2">
            <label htmlFor={step.id} className="block text-[14px] md:text-[14px] lg:text-[14px] leading-4 md:leading-5 lg:leading-6 font-medium text-gray-700">
              {step.question_title}
              {isRequired === true && <span className='text-red-500 ml-1 text-[14px]'>*</span>}
            </label>
            <input

              placeholder="Enter your answer"
              {...commonProps}
              type={question_input_type === 'number' ? 'number' : 'text'}
            />
            {formErrors[id] && <p className="mt-[-4px] text-sm text-red-500">{formErrors[id]}</p>}
          </div>
        );
      case 'number':
        return (
          <div key={step.id} className='mb-2 md:mb-4 lg:mb-4 flex flex-col gap-y-1 md:gap-y-2 lg:gap-y-2'>
            <label htmlFor={step.id} className="block text-[14px] md:text-[14px] lg:text-[14px] leading-4 md:leading-5 lg:leading-6 font-medium text-gray-700">
              {step.question_title}
              {isRequired === true && <span className='text-red-500 ml-1 text-[14px]'>*</span>}
            </label>
            <input
              placeholder="Enter your answer"
              {...commonProps}
              type={question_input_type === 'number' ? 'number' : 'textarea'}
            />
            {formErrors[id] && <p className="mt-[-4px] text-sm text-red-500">{formErrors[id]}</p>}
          </div>
        )
      case 'dropdown':
        const dropdownOptions = JSON.parse(step.question_input_option);
        return (
          <div key={id} className="mb-4"
          >
            <Listbox
              as="div"
              value={formValues[id]?.response || ''}
              onChange={(value) => handleInputChange(id, value, step)}
            >
              <label className="block text-[14px] md:text-[14px] lg:text-[14px] leading-4 md:leading-5 lg:leading-6 font-medium text-gray-700">
                {question_title}
                {isRequired === true && <span className='text-red-500 ml-1 text-[14px]'>*</span>}
              </label>
              <div className="relative mt-2 md:mt-3 lg:mt-3">
                <Listbox.Button
                  className={`relative w-full cursor-default rounded-md bg-white py-[7px] pl-4 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ${formErrors[id] ? 'ring-red-500' : 'ring-gray-300'} focus:outline-none focus:ring-2 !outline-offset-[-1px] input_hover sm:text-sm sm:leading-6`}
                >
                  <span className="block truncate text-gray-700">
                    {formValues[id]?.response || 'Select an option'} {/* ✅ Fixed here */}
                  </span>
                  <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2"></span>
                </Listbox.Button>

                <Listbox.Options
                  className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                >
                  {dropdownOptions?.map((option) => (
                    <Listbox.Option
                      key={option?.id}
                      value={option?.label}
                      className="relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 bg-hover-color hover:text-white"
                    >
                      {({ selected, active }) => (
                        <>
                          <span className={`block truncate ${selected ? 'font-semibold text-[14px] md:text-[16px] lg:text-[16px]' : 'font-normal text-[14px] md:text-[16px] lg:text-[16px]'}`}>
                            {option?.label}
                          </span>
                          {selected && (
                            <span className={`absolute inset-y-0 right-0 flex items-center pr-4 ${active ? 'text-white' : 'text-color'}`}>
                              <CheckCircleColorIcon className="h-5 w-5" aria-hidden="true" />
                            </span>
                          )}
                        </>
                      )}
                    </Listbox.Option>
                  ))}
                </Listbox.Options>
              </div>
            </Listbox>


            {formErrors[id] && <p className="mt-[-4px] text-sm text-red-500 inline-block">{formErrors[id]}</p>}
          </div>
        );
      case 'radio':
        const radioOptions = JSON.parse(step.question_input_option);
        return (
          <div key={id} className="mb-2 md:mb-4 lg:mb-4 flex flex-col gap-y-1 md:gap-y-2 lg:gap-y-2">
            <fieldset>
              <legend className="block text-[14px] md:text-[14px] lg:text-[14px] leading-4 md:leading-5 lg:leading-6 font-medium text-gray-700">
                {step.question_title}
                {isRequired === true && <span className='text-red-500 ml-1 text-[14px]'>*</span>}
              </legend>
              <div className="mt-2 md:mt-3 lg:mt-3 flex flex-col gap-y-3">
                {/* {Object.entries(radioOptions).map(([value, { label }]) => (
                  console.log(label,"valuevaluevalue"),
                  
                  <div key={value} className="flex items-center space-x-2 md:space-x-3 lg:space-x-3">
                    <input
                      type="radio"
                      id={`${id}-${value}`}
                      name={id}
                      value={value}
                      checked={formValues[id]?.response === value}
                      onChange={(e) => handleInputChange(id, value, step)}
                      className="h-[16px] md:h-[18px] lg:h-[18px] w-[16px] md:w-[18px] lg:w-[18px] border-gray-300 text-indigo-600 focus:ring-indigo-600" />
                    <label htmlFor={`${id}-${value}`} className="text-[14px] md:text-[14px] lg:text-[14px] font-normal text-gray-700">
                      {label}
                    </label>
                  </div>
                ))} */}
                {Object.entries(radioOptions).map(([_, option]) => ( // Ignore the key, use option object
                  <div key={option.id} className="flex items-center space-x-2 md:space-x-3 lg:space-x-3">
                    <input
                      type="radio"
                      id={`${id}-${option.id}`}
                      name={id}
                      value={option.label}  // ✅ Use label instead of key
                      checked={formValues[id]?.response === option.label}
                      onChange={(e) => handleInputChange(id, option.label, step)} // ✅ Send label
                      className="h-[16px] md:h-[18px] lg:h-[18px] w-[16px] md:w-[18px] lg:w-[18px] border-gray-300 text-color input_hover"
                    />
                    <label htmlFor={`${id}-${option.id}`} className="text-[14px] md:text-[14px] lg:text-[14px] font-normal text-gray-700">
                      {option.label}
                    </label>
                  </div>
                ))}

              </div>
            </fieldset>
            {formErrors[id] && <p className="mt-[-4px] text-sm text-red-500">{formErrors[id]}</p>}
          </div>
        );
      case 'checkbox':
        const checkboxOptions = JSON.parse(step.question_input_option);

        return (
          <div key={id} className="mb-4 flex flex-col gap-y-3">
            <fieldset>
              <legend className="block text-[14px] md:text-[14px] lg:text-[14px] leading-4 md:leading-5 lg:leading-6 font-medium text-gray-700">
                {step.question_title}
                {isRequired === true && <span className='text-red-500 ml-1 text-[14px]'>*</span>}
              </legend>
              <div className="mt-3 flex flex-col gap-y-1 md:gap-y-2 lg:gap-y-2">
                {checkboxOptions.map((option) => {
                  const { id: optionId, label } = option;
                  // const isChecked = formValues[id]?.response?.includes(optionId);
                  const isChecked = formValues[id]?.response?.some(response => response.id === optionId);

                  return (
                    <div key={optionId} className="flex items-center space-x-2 md:space-x-3 lg:space-x-3">
                      <input
                        type="checkbox"
                        id={`${id}-${optionId}`}
                        name={id}
                        value={optionId}
                        checked={isChecked}
                        onChange={(e) => handleCheckboxChange(e, id, optionId, step)}
                        className="h-[16px] md:h-[18px] lg:h-[18px] w-[16px] md:w-[18px] lg:w-[18px] text-color  input_hover border-gray-300 rounded
                    checked:bg-[var(--component-primary-color)] checked:border-[var(--component-primary-color)]
                    focus:ring-2 focus:ring-[var(--hover-primary-color)] cursor-pointer"
                        
                        
                      />
                      <label htmlFor={`${id}-${optionId}`} className="text-[14px] md:text-[14px] lg:text-[14px] font-normal text-gray-700">
                        {label}
                      </label>
                    </div>
                  );
                })}
              </div>
            </fieldset>
            {formErrors[id] && <p className="mt-[-4px] text-sm text-red-500">{formErrors[id]}</p>}
          </div>
        );
      case 'likert':
        const likertOptions = JSON.parse(step.question_input_option);
        return (
          <div key={id} className="mb-4 flex flex-col gap-y-2">
            <fieldset>
              <legend className="block text-[14px] md:text-[14px] lg:text-[14px] leading-4 md:leading-5 lg:leading-6 font-medium text-gray-700">
                {step.question_title}
                {isRequired === true && <span className='text-red-500 ml-1 text-[14px]'>*</span>}
              </legend>
              <div className="mt-3 md:mt-4 lg:mt-4 flex items-center gap-2 flex-wrap lg:flex-nowrap">
                {likertOptions.map(({ id: optionId, label }: any) => (
                  <div key={optionId} className="flex items-center">
                    <input
                      type="radio"
                      id={`${id}-${optionId}`}
                      name={id}
                      value={label}
                      className="hidden peer"
                      checked={formValues[id]?.response === label}
                      onChange={() => handleInputChange(id, label, step)}
                    // onBlur={() => handleBlur(id, label, step)}
                    />
                    <label
                      htmlFor={`${id}-${optionId}`}
                      className="flex items-center justify-center text-gray-700 font-normal peer-checked:font-medium peer-checked:text-white p-2 md:p-4 lg:p-4 border border-gray-300 rounded-md cursor-pointer peer-checked:bg-indigo-600 peer-checked:border-indigo-600"
                    >
                      <span className="text-sm peer-checked:text-color">{label}</span>
                    </label>
                  </div>
                ))}
              </div>
            </fieldset>
            {formErrors[id] && <p className="mt-[-4px] text-sm text-red-500">{formErrors[id]}</p>}
          </div>
        )
      case 'numberscale':
        const numberOptions = JSON.parse(step.question_input_option);
        return (
          <div key={id} className="mb-4 flex flex-col gap-y-2">
            <fieldset>
              <legend className="block text-[14px] md:text-[14px] lg:text-[14px] leading-4 md:leading-5 lg:leading-6 font-medium text-gray-700">{step.question_title}
                {isRequired === true && <span className='text-red-500 ml-1 text-[14px]'>*</span>}
              </legend>
              <div className="mt-3 md:mt-4 lg:mt-4 flex  items-center gap-2 flex-wrap lg:flex-nowrap">
                {numberOptions.map(({ id: optionId, label }: any) => (
                  <div key={optionId} className="flex items-center">
                    <input
                      type="radio"
                      id={`${id}-${optionId}`}
                      name={id}
                      value={label}
                      checked={formValues[id]?.response === label}
                      onChange={() => handleInputChange(id, label, step)}
                      className="hidden peer"
                    />
                    <label
                      htmlFor={`${id}-${optionId}`}
                      className="flex items-center w-[50px] h-[50px] font-normal peer-checked:font-medium justify-center text-gray-700 peer-checked:text-white p-2 md:p-4 lg:p-4 border border-gray-300 rounded-md cursor-pointer peer-checked:bg-indigo-600 peer-checked:border-indigo-600"
                    >
                      <span className="text-sm  peer-checked:text-indigo-600">{label}</span>
                    </label>
                  </div>
                ))}
              </div>
            </fieldset>
            {formErrors[id] && <p className="mt-[-4px] text-sm text-red-500">{formErrors[id]}</p>}
          </div>
        )
      case 'multi select':
        const options = JSON.parse(step?.question_input_option || '[]');
        return (
          <div key={id} className="mb-4 flex flex-col gap-y-2">
            <label htmlFor={id} className="block text-[14px] md:text-[14px] lg:text-[14px] leading-4 md:leading-5 lg:leading-6 font-medium text-gray-700">
              {question_title}
              {isRequired === true && <span className="text-red-500 ml-1 text-[14px]">*</span>}
            </label>

            <div className="relative">
              {selectedValues.length > 0 && (
                <div className="min-h-[42px] p-1 border rounded-md flex flex-wrap gap-1 mb-1">
                  {selectedValues.map(({ id: selectedId, value }) => ( // Use 'value' instead of 'label'
                    <div key={selectedId} className="bg-gray-100 px-2 py-1 rounded-md flex items-center gap-x-1 text-sm text-gray-700">
                      <span>{value}</span>
                      <button type="button" onClick={() => removeSelected(id, selectedId)} className="ml-1 text-gray-500 hover:text-gray-700">
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              )}


              <button
                type="button"
                onClick={() => toggleDropdown(id)}
                className="w-full px-4 py-2 text-left border rounded-md bg-white flex justify-between items-center"
              >
                <span className="block truncate text-gray-700">Select options...</span>
                <svg
                  className={`w-4 h-4 transition-transform ${isOpen[id] ? 'rotate-180' : ''}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {isOpen[id] && (
                <div ref={dropdownRef} className="absolute z-10 w-full mt-1 bg-white border rounded-md shadow-lg max-h-60 overflow-auto">
                  {options.map((option) => (
                    <div
                      key={option.id}
                      className="px-4 py-2 hover:bg-gray-50 cursor-pointer flex justify-between items-center"
                      onClick={() => toggleOption(id, option.id, options)} // Pass 'options' here
                    >
                      <span>{option.label}</span>
                      {selectedValues.some((selected) => selected.id === option.id) && (
                        <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                        </svg>
                      )}
                    </div>
                  ))}

                </div>
              )}
            </div>
          </div>
        );
      case 'video':
        return (
          <div key={step.id} className="mb-4 flex flex-col gap-y-2">
            <label htmlFor={step.id} className="block text-[14px] md:text-[14px] lg:text-[14px] leading-4 md:leading-5 lg:leading-6 font-medium text-gray-700">
              {step.question_title}
              {isRequired === true && <span className='text-red-500 ml-1 text-[14px]'>*</span>}
            </label>
            <div className="flex flex-col items-center border-dashed border border-gray-400 rounded-lg p-0 w-full h-[114px] justify-center cursor-pointer">
              <label className="w-full h-full flex flex-col items-center justify-center cursor-pointer">
                <input
                  type="file"
                  accept="video/*"
                  className="hidden"
                  onChange={handleFileChangeVideo}
                />
                {videoFile ? (
                  <video className="w-full h-full object-cover rounded-md" controls>
                    <source src={videoFile} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <p className="text-gray-600 text-sm">Click to upload a video</p>
                )}
              </label>
            </div>
          </div>
        );
      case 'audio':
        return (
          <div key={step.id} className="mb-4 flex flex-col gap-y-2">
            <label htmlFor={step.id} className="block text-[14px] md:text-[14px] lg:text-[14px] leading-4 md:leading-5 lg:leading-6 font-medium text-gray-700">
              {step.question_title}
              {isRequired === true && <span className='text-red-500 ml-1 text-[14px]'>*</span>}
            </label>
            <div className="flex flex-col items-center border-dashed border border-gray-400 rounded-lg p-0 w-full h-[114px] justify-center cursor-pointer">
              <label className="w-full h-full flex flex-col items-center justify-center cursor-pointer">
                <input
                  type="file"
                  accept="audio/*"
                  className="hidden"
                  onChange={handleFileChangeAudio}
                />
                {audioFile ? (
                  <audio className="w-full h-full object-cover rounded-md" controls>
                    <source src={audioFile} type="audio/mp3" />
                    Your browser does not support the audio tag.
                  </audio>
                ) : (
                  <p className="text-gray-600 text-sm">Click to upload a audio</p>
                )}
              </label>
            </div>
          </div>
        )
      case 'file':
        return (
          <div key={step.id} className="flex flex-col gap-y-2">
            <div className='flex justify-between items-center w-[300px]'>
              <label htmlFor={step.id} className="block text-[14px] md:text-[14px] lg:text-[14px] leading-4 md:leading-5 lg:leading-6 font-medium text-gray-700">
                {step.question_title}
                {isRequired === true && <span className='text-red-500 ml-1 text-[14px]'>*</span>}
              </label>
            
            </div>
            <div className="flex flex-col items-center border-dashed border border-gray-400 rounded-lg w-full h-[114px] justify-center cursor-pointer">
              <label className="w-full h-full flex flex-col items-center justify-center cursor-pointer">
                <input
                  id="fileUpload"
                  type="file"
                  accept=".pdf,.doc,.docx"
                  className="hidden"
                  onChange={(event) => handleFileChange(event, step.id)}
                />
                {file ? (
                  <div className="w-full h-full flex flex-col items-center justify-center">
                    <p className="text-gray-600 text-sm">{fileName}</p>
                  </div>
                ) : (
                  <p className="text-gray-600 text-sm">Click to upload a PDF or DOC</p>
                )}
              </label>
            </div>

            {/* Open Preview Button */}

          </div>
        )
      case 'yes-no':
        return (
          <div key={step.id} className="mb-2 md:mb-4 lg:mb-4 flex flex-col gap-y-1 md:gap-y-2 lg:gap-y-2">
            <label htmlFor={step.id} className="block text-[14px] md:text-[14px] lg:text-[14px] leading-4 md:leading-5 lg:leading-6 font-medium text-gray-700">
              {step.question_title}
              {isRequired === true && <span className='text-red-500 ml-1 text-[14px]'>*</span>}
            </label>
            <div className='flex items-center gap-x-3'>
              <button
                type="button" // This prevents it from acting as a form submit button

                className={`w-[125px] h-[50px] flex items-center justify-center border rounded-md  font-medium transition-all 
              ${selectedYes === "yes" ? "button_yes_no shadow-md text-white" : "border-gray-300 bg-white text-[#374151]"}`}
                onClick={(e) => handleSelectYes("yes", e, step.id)}
              >
                Yes
              </button>

              {/* No Button */}
              <button
                type="button" // This prevents it from acting as a form submit button

                className={`w-[125px] h-[50px] flex items-center justify-center border rounded-md  font-medium transition-all 
              ${selectedYes === "no" ? "button_yes_no text-white" : "border-gray-300 bg-white text-[#374151]"}`}
                onClick={(e) => handleSelectYes("no", e, step.id)}
              >
                No
              </button>
            </div>
            {formErrors[id] && <p className="mt-[-4px] text-sm text-red-500">{formErrors[id]}</p>}
          </div>

        )
      default:
        return null;
    }
  };

  return (
    <form className=" space-y-10 md:space-y-10 lg:space-y-10">
      <Toaster richColors />
      {!showThankYouMessage &&
        <>
          {steps?.length > 0 &&  steps.map(renderFormElement)}
          <div className="!mt-5 pb-4 flex items-center justify-center gap-x-6">

            <button
              onClick={handleSubmit}
              type="submit"
              className='mt-5 md:mt-5 lg:mt-5 capitalize group inline-flex shrink-0 select-none items-center justify-center text-sm font-medium
                       leading-6 transition-colors duration-100 wg-antialiased focus:outline-0 focus-visible:outline focus-visible:outline-2 
                       focus-visible:outline-offset-2 disabled:pointer-events-none gap-0 px-8  py-2 rounded-lg text-white outline-primary
                        disabled:opacity-50 button-hover'
            >
              <div className='flex items-center gap-x-1'>
                {`Submit Application ->`}
                {loadingForm && (
                  <div className="simple-spinner">
                    <span></span>
                  </div>
                )}

              </div>
            </button>

          </div>
        </>
      }


    
    </form>
  );
};

export default ApplicationDyanamic;
